import dayjs from 'dayjs'

const state = {
  noticeList: [],
  hasNew: localStorage.postHasNew === '1',
  seCalendarHasNew: localStorage.seCalendarHasNew === '1',
}

const getters = {

}

const mutations = {
  setNoticeList (state, value) {
    state.noticeList = value
  },
  setHasNew (state, value) {
    localStorage.postHasNew = value ? '1' : '0'
    state.hasNew = value
  },
  setSeCalendarHasNew (state, value) {
    localStorage.seCalendarHasNew = value ? '1' : '0'
    state.seCalendarHasNew = value
  },
}

const actions = {
  index ({ rootState, dispatch }, params) {
    return rootState.axios.get('/post/v1frontend/post/index', { params }).then(async (res) => {
      res.data.list = await dispatch('formatList', res.data.list || [])
      return res
    })
  },
  indexWishwall ({ rootState, dispatch }, params) {
    return rootState.axios.get('/post/v1frontend/post/index', {
      params: {
        type: 'wishwall',
        ...params,
      }
    })
  },
  viewPage ({ rootState, dispatch }, params) {
    return rootState.axios.get('/post/v1frontend/post/view-page', { params }).then(async (res) => {
      if (res.data.list && res.data.list.length) {
        res.data.model = (await dispatch('formatList', res.data.list))[0]
        return res
      }

      res.data.model = (await dispatch('formatList', [res.data.model]))[0]
      return res
    })
  },
  createWelfare ({ rootState }, params) {
    return rootState.axios.post('/post/v1frontend/post/create-welfare', params)
  },
  createWishwall ({ rootState }, params) {
    return rootState.axios.post('/post/v1frontend/post/create-wishwall', params)
  },
  getNoticeList ({ commit, dispatch }) {
    return dispatch('index', {
      type: 'notice',
      pageSize: 10
    }).then(res => {
      commit('setNoticeList', res.data)
    })
  },
  refreshHasNew ({ commit, dispatch, rootState }) {
    let type = 'notice'
    if (rootState.edition === 's') {
      type = 'ntcbiz'
    }
    return dispatch('index', {
      type,
      pageSize: 1,
      objTable: 'empty',
      objid: 'newNotice',
    }).then(res => {
      if (!res.data.error) {
        const noticeItem = res.data.list[0]
        const showNoticeTime = localStorage.showNoticeTime
        if (noticeItem) {
          if (showNoticeTime && dayjs(showNoticeTime) < dayjs(noticeItem.updatedAt)) {
            // 首次访问不显示小红点
            commit('setHasNew', true)
          }
          localStorage.showNoticeTime = noticeItem.updatedAt
        }
      }
    })
  },
  fetchCalendarNotice ({ dispatch }, params) {
    return dispatch('index', {
      type: 'notice',
      pageSize: 10,
      ...params,
    }).then(res => {
      return res.data.list[0]
    })
  },
  refreshSeCalendarHasNew ({ commit, dispatch }, params) {
    return dispatch('index', {
      type: 'notice',
      pageSize: 1,
      objid: 'se',
      ...params,
    }).then(res => {
      if (!res.data.error) {
        const noticeItem = res.data.list[0]
        const seCalendarNoticeTime = localStorage.seCalendarNoticeTime
        if (noticeItem) {
          // 首次访问或有更新都显示未读
          if (!seCalendarNoticeTime || dayjs(seCalendarNoticeTime) < dayjs(noticeItem.updatedAt)) {
            commit('setSeCalendarHasNew', true)
          }
        }
      }
    })
  },
  markSeCalendarAsRead ({ commit }) {
    const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
    localStorage.seCalendarNoticeTime = now
    commit('setSeCalendarHasNew', false)
  },
  formatList ({ state, commit }, sourceList) {
    return sourceList.map(item => {
      if (item.type === 'suspend') {
        const matchR = item.title.match(/(\d{4}-\d{1,2}-\d{1,2})/)
        if (matchR) {
          item.suspendDate = matchR[0]
          item.publishedAt = item.suspendDate
          item.title = item.title.replace(matchR[0], '')
        }
      }
      return item
    })
  },
  createNovice ({ rootState }, params) {
    return rootState.axios.post('/post/v1frontend/post/create-novice', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
